import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AutoUnsubscribe} from '../../decorators/auto-unsubscribe.decorator';
import {NotificationsDrawerService} from './notifications-drawer.service';
import {NotificationsService} from '../../services/notifications.service';
import {RouterExtendedService} from '../../services/router-extended.service';
import {NotificationsQuery} from '../../common/elf-store/notifications/notifications.query';
import {
  GeneralAnnouncementDto,
  NotificationStatus,
  NotificationType,
  UserNotificationDto,
} from '../../types/notifications.type';
import {SUBSCRIPTIONS} from '../../common/utils/constants';
import {DrawerComponent} from 'src/app/components/smart/drawer/drawer.component';
import {EventEmitterService} from 'src/app/services/event-emitter.service';
import {UserInfo} from '../../common/elf-store/user-info/user-info.store';
import {UserInfoQuery} from '../../common/elf-store/user-info/user-info.query';

@Component({
  selector: 'mc-notifications-drawer',
  templateUrl: './notifications-drawer.component.html',
  styleUrls: ['./notifications-drawer.component.scss'],
})
@AutoUnsubscribe()
export class NotificationsDrawerComponent implements OnInit {
  @ViewChild('drawer') drawer: DrawerComponent;
  announcements: any[] = [];
  personalNotifications: UserNotificationDto[] = [];
  isDrawerOpened: boolean = false;
  openedFromUrl: boolean;
  previousUrl: string;
  notificationType = NotificationType;

  readonly NotificationsService = NotificationsService;

  constructor(
    public userInfoQuery: UserInfoQuery,
    private notificationsDrawer: NotificationsDrawerService,
    private notificationsService: NotificationsService,
    private route: ActivatedRoute,
    private routerExtService: RouterExtendedService,
    private notificationsQuery: NotificationsQuery,
    private eventEmitterService: EventEmitterService,
  ) {
    this.previousUrl = this.routerExtService.getPreviousUrl();
  }

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      if (data?.openedFromUrl) {
        this.openedFromUrl = true;
      }
    });
    this[SUBSCRIPTIONS].add(
      this.eventEmitterService.closeDrawer.subscribe(() => {
        this.close();
      }),
    );

    this[SUBSCRIPTIONS].add(
      this.notificationsDrawer.opened.subscribe(opened => {
        if (opened || this.openedFromUrl) {
          this.open();
        }
        this.isDrawerOpened = opened;
      }),
    );

    this[SUBSCRIPTIONS].add(
      this.notificationsQuery.personalNotifications$.subscribe((notificationList: UserNotificationDto[]) => {
        this.personalNotifications = notificationList;
      }),
    );
    this[SUBSCRIPTIONS].add(
      this.notificationsQuery.generalAnnouncements$.subscribe((notificationList: GeneralAnnouncementDto[]) => {
        this.announcements = notificationList;
      }),
    );
  }

  close() {
    this.notificationsDrawer.close();
    this.notificationsService.updateNotifications(this.personalNotifications);
    this.notificationsService.calculateUnReadNotifications(this.personalNotifications, this.announcements);

    if (!this.openedFromUrl) {
      return;
    }

    if (this.previousUrl) {
      window.history.back();
      return;
    }
  }

  open() {
    setTimeout(() => {
      this.drawer['closeButton']?.nativeElement?.focus();
    }, 250);

    this.notificationsService.clearUnreadNotifications();
  }

  readAllNotifications() {
    const ids = this.personalNotifications
      .filter(
        item => item.status === NotificationStatus.NEW && !this.notificationsService.isNoCardTrialNotification(item),
      )
      .map(el => el.id);
    if (ids.length) {
      this[SUBSCRIPTIONS].add(this.notificationsService.readAllNotifications(ids, NotificationStatus.READ).subscribe());
      this.personalNotifications.forEach(notification => ({...notification, status: NotificationStatus.READ}));
    }
  }

  readNotification(notificationStatus: NotificationStatus, notification: UserNotificationDto) {
    if (this.notificationsService.isNoCardTrialNotification(notification)) {
      return;
    }

    let status = notificationStatus;
    if (status === NotificationStatus.DISMISS && notification.status === status) {
      status = NotificationStatus.READ;
    }

    const updatedNotification: UserNotificationDto = {
      ...notification,
      status,
    };

    this.personalNotifications = this.personalNotifications.map(n =>
      n.id === updatedNotification.id ? updatedNotification : n,
    );

    this[SUBSCRIPTIONS].add(this.notificationsService.readNotification(notification.id, status).subscribe());
  }
}
